import Vue from '@/index.js'

import page from '@/mixins/page'

import sectionCompare from '@/components/sections/section-compare'

export default new Vue({
  el: '#app',
  components: {
    sectionCompare
  },
  mixins: [page]
})
